import { render } from "./customer_services_individual.vue?vue&type=template&id=f6b31cdc&scoped=true"
import script from "./customer_services_individual.vue?vue&type=script&lang=js"
export * from "./customer_services_individual.vue?vue&type=script&lang=js"

import "./customer_services_individual.vue?vue&type=style&index=0&id=f6b31cdc&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b31cdc"]])

export default __exports__